import { createSlice } from "@reduxjs/toolkit";
import axios from "../../utils/axios";
const backendUrl = process.env.REACT_APP_BACKEND_URL;

const initialState = {
  isLoading: false,
  error: null,
  categories: [],
  venuesCategories: [],
  category: null,
};

const slice = createSlice({
  name: "category",
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET CATEGORIES
    getCategoriesSuccess(state, action) {
      state.isLoading = false;
      state.categories = action.payload;
    },
    // GET TERMINAL-SPECIFIC CATEGORIES
    getVenuesCategoriesSuccess(state, action) {
      state.isLoading = false;
      state.venuesCategories = action.payload;
    },

    // GET CATEGORY
    getCategorySuccess(state, action) {
      state.isLoading = false;
      state.category = action.payload;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
// export const {
// } = slice.actions;

// ----------------------------------------------------------------------

export function getCategories(franchiseId) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const resolvedFranchiseId =
        franchiseId?.id || franchiseId?._id || franchiseId;
      if (!resolvedFranchiseId || typeof resolvedFranchiseId !== "string") {
        throw new Error("Franchise ID is missing");
      }

      const response = await axios.get(`${backendUrl}/franchiseCategory`, {
        params: { franchiseId: resolvedFranchiseId, limit: 100000 },
      });
      dispatch(slice.actions.getCategoriesSuccess(response.data.results));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getVenuesCategories(id) {
  return async (dispatch) => {
   dispatch(slice.actions.startLoading());
    try {
     const response = await axios.get(`${backendUrl}/franchiseCategory/getVenueCategories/${id}`);
      dispatch(slice.actions.getVenuesCategoriesSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}


// ----------------------------------------------------------------------

export function getCategory(categoryId) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(
        `${backendUrl}/franchiseCategory/${categoryId}`
      );
      dispatch(slice.actions.getCategorySuccess(response.data));
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}
